import type { LedgerClassification } from './types';

/**
 * Finnish pipeline tags for Cronos rows that are excluded from FIFO (non-taxable internal).
 * Aligns with balanced policy: same beneficial ownership → no disposal by default.
 */
export function fiMetaForCronosInternalRow(
  classification: LedgerClassification,
  options?: { fiSubreason?: string }
): {
  fiTaxCategory: 'NON_TAXABLE_INTERNAL';
  fiSubreason: string;
} {
  if (options?.fiSubreason) {
    return { fiTaxCategory: 'NON_TAXABLE_INTERNAL', fiSubreason: options.fiSubreason };
  }
  const fiSubreason =
    classification === 'SELF_TRANSFER'
      ? 'CRONOS_SELF_TRANSFER'
      : classification === 'APPROVAL'
        ? 'CRONOS_APPROVAL'
        : classification === 'IGNORE_NON_TAX'
          ? 'CRONOS_IGNORE_NON_TAX'
          : 'CRONOS_OWNED_TO_OWNED';
  return { fiTaxCategory: 'NON_TAXABLE_INTERNAL', fiSubreason };
}

/** Finnish pipeline tags for Arbitrum explorer rows excluded from FIFO (non-taxable internal). */
export function fiMetaForArbitrumInternalRow(
  classification: LedgerClassification,
  options?: { fiSubreason?: string }
): {
  fiTaxCategory: 'NON_TAXABLE_INTERNAL';
  fiSubreason: string;
} {
  if (options?.fiSubreason) {
    return { fiTaxCategory: 'NON_TAXABLE_INTERNAL', fiSubreason: options.fiSubreason };
  }
  const fiSubreason =
    classification === 'SELF_TRANSFER'
      ? 'ARBITRUM_SELF_TRANSFER'
      : classification === 'APPROVAL'
        ? 'ARBITRUM_APPROVAL'
        : classification === 'IGNORE_NON_TAX'
          ? 'ARBITRUM_IGNORE_NON_TAX'
          : 'ARBITRUM_OWNED_TO_OWNED';
  return { fiTaxCategory: 'NON_TAXABLE_INTERNAL', fiSubreason };
}
